import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { setAxiosAuth } from 'utils';
import { assetsApi } from 'core/api/assets.api';

export const useGetAgreement = ({ accessToken = '', assetId = '' }) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.agreement, assetId],
    queryFn: async () => await assetsApi.getAssetAgreement(assetId),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken && assetId),
  });
}
